/** One GA4 ecommerce item, as the legacy skytree tags expect it. */
export interface GAItem {
  item_id: string;
  item_name: string;
  affiliation?: string;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  price?: number;
  quantity?: number;
}

export interface EcommerceUnitInput {
  id?: string;
  name?: string;
  amount?: number;
  displayAmount?: number;
  quantity?: number;
}

export function planUnitItemsToUnits(
  items: Array<{
    unitId?: string;
    title?: string;
    amount?: number;
    displayAmount?: number;
    count?: number;
  }>
): EcommerceUnitInput[] {
  return items.map(item => ({
    id: item.unitId,
    name: item.title,
    amount: item.amount,
    displayAmount: item.displayAmount,
    quantity: item.count
  }));
}

export interface BuildEcommerceItemsParams {
  activityId?: string;
  activityTitle?: string;
  planId?: string;
  planTitle?: string;
  agentId?: string;
  units: EcommerceUnitInput[];
  showOtherCurrencies?: boolean;
}

export function buildEcommerceItems({
  activityId = '',
  activityTitle = '',
  planId = '',
  planTitle = '',
  agentId = '',
  units,
  showOtherCurrencies = false
}: BuildEcommerceItemsParams): GAItem[] {
  return units
    .filter(u => (u.quantity ?? 0) > 0)
    .map(unit => ({
      item_id: `${activityId}:${planId}:${unit.id ?? ''}:${unit.id ?? ''}`,
      item_name: `${activityTitle}:${planTitle}:${unit.name ?? ''}`,
      affiliation: agentId,
      item_category: activityId,
      item_category2: planId,
      item_category3: unit.id ?? '',
      item_list_id: activityId,
      item_list_name: activityTitle,
      item_variant: `${unit.id ?? ''}:${unit.name ?? ''}`,
      price: showOtherCurrencies
        ? (unit.displayAmount ?? 0)
        : (unit.amount ?? 0),
      quantity: unit.quantity ?? 0
    }));
}
